module.exports = __webpack_public_path__ + "img/1280x720-Showtime.7d2a83c4.jpg";